export const PAISES = ["Colombia", "México", "Perú", "Chile", "Otro"];

export const DEPARTAMENTOS_CO = [
  "Antioquia",
  "Cundinamarca",
  "Valle del Cauca",
  "Atlántico",
];

export const CIUDADES_CO: Record<string, string[]> = {
  Antioquia: ["Medellín", "Bello", "Itagüí"],
  Cundinamarca: ["Bogotá", "Soacha", "Chía"],
  "Valle del Cauca": ["Cali", "Palmira", "Buenaventura"],
  Atlántico: ["Barranquilla", "Soledad"],
};

export const TIPOS_SOLICITUD = [
  { label: "Vinculación", value: "vinculacion" },
  { label: "Actualización", value: "actualizacion" },
];

export const TIPOS_TERCERO: { value: string; label: string }[] = [
  { label: "Cliente", value: "cliente" },
  { label: "Proveedor", value: "proveedor" },
  { label: "Contratista", value: "contratista" },
  { label: "Accionista", value: "accionista" },
  { label: "Miembro de junta directiva", value: "miembro_junta" },
];

export const TIPOS_DOCUMENTO: { value: string; label: string }[] = [
  { label: "C.C", value: "CC" },
  { label: "C.E", value: "CE" },
  { label: "Pasaporte", value: "PAS" },
  { label: "NIT", value: "NIT" },
];

export const TIPOS_EMPRESA: { value: string; label: string }[] = [
  { label: "Publica", value: "Publica" },
  { label: "Mixta", value: "Mixta" },
  { label: "Privada", value: "Privada" },
  { label: "Extranjera", value: "Extranjera" },
];

export const CIIU_OPTIONS = [
  { value: "0111", label: "Cultivo de cereales" },
  { value: "6201", label: "Desarrollo de sistemas informáticos" },
  { value: "4711", label: "Comercio al por menor en establecimientos" },
];
